import React from 'react'
import {COLOR_LIST} from "../common/constants/color.constant";
import _ from "lodash";

const colorList = _.orderBy(COLOR_LIST, 'colorKey');

const EditStrokeDetails = ({parentForm, handleStrokeDetailsChanges}) => {
    const colorMap = _.keyBy(COLOR_LIST, 'colorKey');

    return (
        <>

            <div className="ml-2 field-label">
                Stroke
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field"
                            id="strokeWidth"
                            name="strokeWidth"
                            value={parentForm?.strokeWidth}
                            onChange={handleStrokeDetailsChanges}>
                        </input>
                    </div>

                </div>
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="strokeColorKey"
                            name="strokeColorKey"
                            value={parentForm?.strokeColorKey}
                            onChange={handleStrokeDetailsChanges}>
                            <option value="">Choose Stroke Color</option>
                            {colorList?.map((colorDetail, index) => (
                                <option key={index}
                                        value={colorDetail.colorKey}>{colorDetail.colorName}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="strokeColorCodeKey"
                            name="strokeColorCodeKey"
                            value={parentForm?.strokeColorCodeKey}
                            onChange={handleStrokeDetailsChanges}>
                            <option value="">Choose Shade</option>
                            {colorMap[parentForm?.strokeColorKey]?.colorCodes.map((colorCodeDetail, index) => (
                                <option key={index}
                                        value={colorCodeDetail.colorCodeKey}>{colorCodeDetail.colorCodeName}</option>
                            ))}
                        </select>
                    </div>

                </div>
            </div>

        </>
    )
}

export default EditStrokeDetails
